var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIntegrationsMenuItemHover(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.75 2.75H10.25V6.00287H9.75002V3.25H1.25V17.1638H16.8965L15.7323 15.9996C15.6346 15.9019 15.6346 15.7437 15.7323 15.646C15.8299 15.5484 15.9882 15.5484 16.0858 15.646L17.6768 17.237C17.7744 17.3346 17.7744 17.4929 17.6768 17.5906L16.0858 19.1816C15.9882 19.2792 15.8299 19.2792 15.7323 19.1816C15.6346 19.0839 15.6346 18.9256 15.7323 18.828L16.8965 17.6638H0.75V2.75Z",
    fill: "#2D2943"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.549805 2.55078H10.4498V6.20366H9.54982V3.45078H1.4498V16.9646H16.4134L15.5907 16.1418C15.4149 15.966 15.4149 15.6811 15.5906 15.5054C15.7664 15.3296 16.0513 15.3296 16.227 15.5054L17.818 17.0964C17.9938 17.2721 17.9938 17.557 17.818 17.7328L16.227 19.3238C16.0513 19.4995 15.7664 19.4995 15.5907 19.3238C15.4149 19.148 15.4149 18.8631 15.5907 18.6874L16.4134 17.8646H0.549805V2.55078Z",
    fill: "#2D2943"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.25 25.25H12.75V21.9971H13.25V24.75H21.75V10.8362L6.10352 10.8362L7.26773 12.0004C7.36536 12.0981 7.36536 12.2563 7.26773 12.354C7.1701 12.4516 7.01181 12.4516 6.91418 12.354L5.32319 10.763C5.22556 10.6654 5.22556 10.5071 5.32319 10.4094L6.91418 8.81844C7.01181 8.72081 7.1701 8.72081 7.26773 8.81844C7.36536 8.91607 7.36536 9.07436 7.26773 9.17199L6.10352 10.3362L22.25 10.3362L22.25 25.25Z",
    fill: "#2D2943"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.4502 25.4512H12.5502V21.7983H13.4502V24.5512H21.5502V11.0374L6.58656 11.0374L7.40935 11.8602C7.58509 12.0359 7.58509 12.3208 7.40935 12.4966C7.23361 12.6723 6.94869 12.6723 6.77295 12.4966L5.18196 10.9056C5.00623 10.7298 5.00623 10.4449 5.18196 10.2692L6.77295 8.67819C6.94869 8.50245 7.23361 8.50245 7.40935 8.67819C7.58509 8.85393 7.58509 9.13885 7.40935 9.31459L6.58656 10.1374L22.4502 10.1374L22.4502 25.4512Z",
    fill: "#2D2943"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntegrationsMenuItemHover);
export default __webpack_public_path__ + "static/media/integrations-menu-item-hover.ec12f9ae.svg";
export { ForwardRef as ReactComponent };